module.exports = __webpack_public_path__ + "static/media/Physiofit-2.0b1edf25.jpg";